import { Component, OnInit, Input, ElementRef, ViewChild, HostListener, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@src/environments/environment'
import { CardPreviewService, IMediaBackground, IWeblinkIcons, iconsWeblink, IBrandcard, IBrandcardResult, EnumIcons } from '@app/components/card-preview'
import {cardData} from './mock.data'

import * as _ from 'lodash'

@Component({
    selector: 'app-card-preview',
    templateUrl: './card-preview.component.html',
    styleUrls: ['./card-preview.component.scss']
})

export class CardPreviewComponent implements OnInit, AfterViewInit {
  @Input() mediaData: IBrandcardResult
  @Input() cardIcon: string | null
  @Input() cardLogo: string | null
  @Input() cardWallpaper: any
  @Input() barColor: string
  @Input() fullPreview = false
  @Input() currentStep: number
  @Input() heightFrame: string
  @Input() widthFrame: string
  @ViewChild('divToScroll', {static: true}) divToScroll: ElementRef;
  @ViewChild('videoPlayer', {static: true}) videoPlayerElement: ElementRef
  @ViewChild('wrapperElement', {static: true}) wrapperElement: ElementRef
  @ViewChild('headerTopElement', {static: true}) headerTopElement: ElementRef
  @ViewChild('logoElement', {static: true}) logoElement: ElementRef

  isMediaSoundBackgroundMute = true
  isShowBackButton = false
  isShowContainerIcons = false
  isShowAllActions = null
  isShowFeatureContent = false
  isShowProfile = false
  isHideAllContain = false
  iconLogoToDefault = false
  iconLogoToTop = false
  iconLogoToBottom = false
  isScreen2 = false
  isShowModalCardInfo = false
  innerWidth: number
  isWindowInnerHeightGreater800 = true
  isShowProfileInfo = false
  isMediaSoundDisable: boolean
  wrapperHeight: number
  headerHeight: number
  logoHeight: number
  bgHeight: number
  iconsAnimation = false
  isShowActionTextIcons = false
  isShowActionSocialLinkIcons = false
  isShowAllIcons = false
  defaultVideoBackground = 'https://dmedia.gozero.tech/98/card/176/wallpaper/wallpaper176_1608693979380.mp4'
  isDataModified = false
  nobackground:boolean = false;

  weblinkIcons: IWeblinkIcons = iconsWeblink

  constructor(
    private route: ActivatedRoute,
    private brandcardService: CardPreviewService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngAfterViewInit() {
    // this.wrapperHeight = this.wrapperElement.nativeElement.offsetHeight
    // this.brandcardService.setTotalHeightCardFrame(this.wrapperHeight)
  }

  ngOnInit(): void {
    this.mapCardData()
    this.listenToSubscriber()
    if (isPlatformBrowser(this.platformId)) {
      this.innerWidth = this.brandcardService.getWindow().innerWidth
    }
    this.calculateHigh()
    this.isDisplayProfileInfo()

    // custom image
    if (this.currentStep === 1 || this.currentStep === 7) {
      this.isShowAllActions = false
      this.iconsAnimation = false
      this.brandcardService.setShowAllActions(this.isShowAllActions)
      this.brandcardService.setStatusDisplayAllIcons(false)
      this.brandcardService.setScreen2(false)
      this.brandcardService.setEnableDisableBackground({isPlay: true, isMute: true, triggerFrom: 'main screen'})
    }

    // feature content
    if (this.currentStep === 2) {
        this.isHideAllContain = true
        this.isShowFeatureContent = true
        this.isShowAllActions = false
        this.iconsAnimation = false
        this.brandcardService.setScreen2(true)
    }

    // custom color
    if (this.currentStep === 4) {
      this.isShowAllActions = true
      this.iconsAnimation = true
      this.brandcardService.setShowAllActions(this.isShowAllActions)
      this.brandcardService.setStatusDisplayAllIcons(true)
      this.brandcardService.setEnableDisableBackground({isPlay: true, isMute: true, triggerFrom: 'main screen'})
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (isPlatformBrowser(this.platformId)) {
      this.innerWidth = this.brandcardService.getWindow().innerWidth
      if (this.brandcardService.getWindow().innerHeight <= 800) {
        this.isWindowInnerHeightGreater800 = false
      } else {
        this.isWindowInnerHeightGreater800 = true
      }
    }

    if (this.isShowModalCardInfo) {
      this.headerHeight = this.headerTopElement.nativeElement.offsetHeight
      this.logoHeight = this.logoElement.nativeElement.offsetHeight
  
      this.brandcardService.setTotalHeightHeeaderImage({header_wrap: this.headerHeight, image_wrap: this.logoHeight})
    }
  }

  get frameBasiStyles() {
    return {
      'margin': '0 auto',
      'height': `${this.heightFrame}px`,
      'width': `${this.widthFrame}px`
    }
  }

  getYPosition(e: Event): number {
    return (e.target as Element).scrollTop;
  }

  calculateHigh() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.brandcardService.getWindow().innerHeight <= 800) {
        this.isWindowInnerHeightGreater800 = false
      } else {
        this.isWindowInnerHeightGreater800 = true
      }
    }
  }

  onMouseWheel(event: any) {
    if (!this.fullPreview)
        return

    if (!this.isScreen2 && event.deltaY > 0) {
      //  scroll up
      this.brandcardService.setShowAllActions(true)
      this.brandcardService.setStatusDisplayAllIcons(true)
      this.brandcardService.setEnableDisableBackground({isPlay: true, isMute: true, triggerFrom: 'mouse scroll'})
    }
    if (!this.isScreen2 && event.deltaY < 0) {
      //  scroll down
      this.brandcardService.setShowAllActions(false)
      this.brandcardService.setStatusDisplayAllIcons(false)
      this.brandcardService.setEnableDisableBackground({isPlay: true, isMute: true, triggerFrom: 'mouse scroll'})
    }
  }

  allActions() {
    console.log(this.currentStep)
    if (this.currentStep === 1 || this.currentStep === 4)
        return

    this.isMediaSoundDisable = true
    const isShowAllActions = !this.isShowAllActions
    this.brandcardService.setShowAllActions(isShowAllActions)
    if (isShowAllActions) {
      this.brandcardService.setStatusDisplayAllIcons(true)
      this.brandcardService.setEnableDisableBackground({isPlay: true, isMute: true, triggerFrom: 'main screen'})
    } else {
      this.brandcardService.setStatusDisplayAllIcons(false)
      this.brandcardService.setEnableDisableBackground({isPlay: true, isMute: true, triggerFrom: 'main screen'})
    }
  }

  mediaTrigger() {
    // console.log('isMediaSoundDisable ',this.isMediaSoundDisable)
    // console.log('isShowAllActions ',this.isShowAllActions)
    // console.log('isShowModalCardInfo ',this.isShowModalCardInfo)
    // console.log('videoPlayer muted ',this.brandcardService.getElementById('videoPlayer').muted)
    if (!this.isMediaSoundDisable && !this.isShowAllActions && !this.isShowModalCardInfo) {
      if (this.brandcardService.getElementById('videoPlayer').muted) {
        this.brandcardService.setEnableDisableBackground({isPlay: true, isMute: false, triggerFrom: 'on touch screen'})
      } else {
        this.brandcardService.setEnableDisableBackground({isPlay: true, isMute: true, triggerFrom: 'on touch screen'})
      }
    }

    this.isMediaSoundDisable = false
  }

  gotoMainScreen() {
    this.isMediaSoundDisable = true
    this.brandcardService.setShowAllActions(false)
    this.brandcardService.setEnableDisableBackground({isPlay: true, isMute: true, triggerFrom: '2nd Screen'})
  }

  backToContainerIcons() {
    this.brandcardService.setScreen2(false)

    if (this.isShowModalCardInfo) {
      this.isShowModalCardInfo = false
      const isShowAllActions = !this.isShowAllActions
      this.brandcardService.setShowAllActions(false)
      this.brandcardService.setEnableDisableBackground({isPlay: true, isMute: true, triggerFrom: 'back icon'})
      return
    }
    // set false then true because to make all icons appear in 500miliseconds
    this.brandcardService.setShowAllActions(false)
    this.brandcardService.setShowAllActions(true)

    this.brandcardService.setShowMessageIcons(false)
    this.brandcardService.setShowSocialLinkIcons(false)
    this.brandcardService.setStatusDisplayAllIcons(true)
    this.brandcardService.setProfileLogoToBottom(false)
    this.brandcardService.setProfileLogoToTop(false)
    this.isShowBackButton = false
    this.brandcardService.setEnableDisableBackground({isPlay: true, isMute: true, triggerFrom: 'back icon'})
  }

  listenIconAction(event: string) {
    if (event === EnumIcons.Text || event === EnumIcons.Social_Link) {
      this.isShowBackButton = true
    }
    if (event === EnumIcons.Featured_Content) {
      this.isHideAllContain = true
      this.isShowFeatureContent = true
    }
    if (event === EnumIcons.Profile) {
      this.isHideAllContain = true
      this.isShowProfile = true
    }
  }

  listenToSubscriber() {
    this.brandcardService.currentStatusDisplayAllIcons.subscribe((event: boolean) => {
      this.iconLogoToDefault = event
      this.isShowAllIcons = event
    })
    this.brandcardService.currentProfileLogoToBottom.subscribe((event: boolean) => {
      this.iconLogoToBottom = event
    })
    this.brandcardService.currentProfileLogoToTop.subscribe((event: boolean) => {
      this.iconLogoToTop = event
    })
    this.brandcardService.currentScreen2.subscribe((event: boolean) => {
      this.isScreen2 = event
    })
    this.brandcardService.currentShowAllActions.subscribe((event: boolean) => {
      this.isShowAllActions = event
      if (event) {
        setTimeout(() => {
          this.iconsAnimation = event
        }, 400);
      } else {
        this.iconsAnimation = event
      }
    })

    this.brandcardService.currentenableDisableBackgroundSound.subscribe((event: IMediaBackground) => {
      const videoElement = this.brandcardService.getElementById('videoPlayer')
      if (videoElement) {
        if (event.isPlay) {
          // videoElement.play()
          videoElement.isPlay = event
        } else {
          // videoElement.pause()
          videoElement.isPlay = event
        }
        videoElement.muted = event.isMute ? true : false
      }
    })

    this.brandcardService.currentShowMessageIcons.subscribe((status: boolean) => {
      this.isShowActionTextIcons = status
    })

    this.brandcardService.currentShowSocialLinkIcons.subscribe((status: boolean) => {
      this.isShowActionSocialLinkIcons = status
    })
  }

  listenOnGoBack(event: boolean) {
    // feature content
    if (this.currentStep === 2) {
        return
    }
    this.isHideAllContain = false
    this.isShowProfile = false
    this.isShowFeatureContent = false
    this.brandcardService.setShowAllActions(false)
    this.brandcardService.setShowAllActions(true)
    this.brandcardService.setStatusDisplayAllIcons(true)
    this.brandcardService.setEnableDisableBackground({isPlay: true, isMute: true, triggerFrom: 'go back icon'})
  }

  openCardInfo() {
    if (this.currentStep === 1 || this.currentStep === 4 || this.isScreen2)
      return

    // whitecard & privatecard dont have this feature
    if (
      this.mediaData.type === 'BC' ||
      (this.mediaData.type === 'BC' && this.mediaData.is_comcard) ||
      this.mediaData.type === 'SC' ||
      this.mediaData.type === 'SC' && this.mediaData.is_comcard
    ) {
      const isShowAllActions = !this.isShowAllActions
      this.brandcardService.setShowAllActions(false)
      this.brandcardService.setScreen2(true)
      this.isShowModalCardInfo = !this.isShowModalCardInfo
      // this.brandcardService.setShowModalCardInfo(this.isShowModalCardInfo)
      this.brandcardService.setEnableDisableBackground({isPlay: true, isMute: true, triggerFrom: 'open card info'})
    }
  }

  getModalDisplay(event: boolean) {
    this.isShowModalCardInfo = event
  }

  isDisplayProfileInfo() {
    // whitecard & privatecard
    if (
      this.mediaData.type === 'BC' ||
      (this.mediaData.type === 'BC' && this.mediaData.is_comcard) ||
      this.mediaData.type === 'SC' ||
      this.mediaData.type === 'SC' && this.mediaData.is_comcard
    ) {
      this.isShowProfileInfo = true
    }
  }

  showPrivateModal() {
    this.brandcardService.setShowModal({display: true, which_text: 'private'})
  }

  getVCard() {
    this.brandcardService.generateVCard(this.mediaData, this.route.snapshot.params['id'])
  }

  featureContentGetMediaType(uri: string) {
    // is media youtube
    const youtube_types = ['youtube', 'youtu.be']
    const isYoutube = youtube_types.some(type => uri.includes(type))
    if (isYoutube) {
      return 'youtube'
    }
    // is media photo gif
    const video_types = ['mp4', 'mov', 'wmv', 'flv', 'avi', 'avchd', 'webm', 'mkv', 'qt']
    const url_extension = uri.split('.').pop().toLowerCase()
    const is_video = video_types.some(ext => url_extension.includes(ext))
    if (is_video) {
      return 'video'
    }
    // is media photo gif
    const image_gif = ['jpeg', 'jpg', 'png', 'gif']
    const urlExtension = uri.split('.').pop().toLowerCase()
    const is_image_gif = image_gif.some(ext => urlExtension.includes(ext))
    if (is_image_gif) {
      return 'photo'
    }
    // is media pdf
    const isPdf = uri.includes('pdf')
    if (isPdf) {
      return 'pdf'
    }
  }

  isParamString(param: any) {
    return typeof param === 'string'
  }

  mapCardData = () => {
    if (this.mediaData.featured_contents && !!this.mediaData.featured_contents.length) {
      for(const feature of this.mediaData.featured_contents) {
        feature.isMedia = this.featureContentGetMediaType(feature.uri)
        feature.longText = true

        if ((feature.isMedia === 'youtube' && feature.uri.includes('youtu.be')) && !this.brandcardService.getPlatform().IOS) {
          const lastSegmen = feature.uri.substr(feature.uri.lastIndexOf('/') + 1);
          feature.uri = `https://www.youtube.com/embed/${lastSegmen}`

        }

        if (feature.isMedia === 'youtube' && feature.uri.includes('watch')) {
          const uri = feature.uri
          feature.uri = uri.replace('watch?v=','embed/');
        }
      }
    }  
    if (this.mediaData.background_url === '' || !this.mediaData.background_type) {
      this.mediaData.background_url = this.defaultVideoBackground
    }

    this.mediaData.is_background_image = this.hasExtension(this.mediaData.background_url)
    if (this.mediaData.social_links) {
      const {www, googlemap, vimeo, ...restSocialLink} = this.mediaData.social_links
      const socialLink = {...restSocialLink}
      this.mediaData.info_links = {www, googlemap}
      this.mediaData.socials = Object.keys(socialLink).map((key, index) => {
        if (key === 'facebook') {
          return {label: 'facebook', link: socialLink[key]}
        } else if (key === 'youtube') {
          return {label: 'youtube', link: socialLink[key]}
        } else if (key === 'instagram') {
          return {label: 'instagram', link: socialLink[key]}
        } else if (key === 'linkedin') {
          return {label: 'linkedin', link: socialLink[key]}
        } else if (key === 'twitter') {
          return {label: 'twitter', link: socialLink[key]}
        } else if (key === 'vimeo') {
          return {label: 'vimeo', link: socialLink[key]}
        }
      })
      // remove link empty
      this.mediaData.socials = this.mediaData.socials.filter(social => social.link !== '')
    }
    // this.mediaData.combine_profiles = {...this.mediaData.profiles.user_profile, ...this.mediaData.profiles.card_profile}

    this.mediaData = {
      ...this.mediaData
    }
    console.log(this.mediaData)

    this.isDataModified = true

    setTimeout(() => {
      this.wrapperHeight = this.wrapperElement.nativeElement.offsetHeight
      this.brandcardService.setTotalHeightCardFrame(this.wrapperHeight)
    }, 2000);
  }

  hasExtension(background_url: string) {
    const extension = background_url.split('.').pop()
    const image_gif = ['jpeg', 'jpg', 'png', 'gif', 'GIF', 'JPG', 'JPEG', 'PNG']

    const is_image_gif = image_gif.some(ext => extension.includes(ext))
    if (is_image_gif) {
      return true
    }

    return false
  }

}
